import { serialize } from './helper/utils.js';
import { isObject, isEmptyString } from './helper/validator.js';

export default class Launcher {
  _serviceUrl = null;
  _params = null;

  constructor(serviceUrl, uriParams) {
    if (!isEmptyString(serviceUrl)) this.setServiceUrl(serviceUrl);
    if (isObject(uriParams)) this.setUriParams(uriParams);
  }

  setServiceUrl(serviceUrl) {
    if (isEmptyString(serviceUrl)) {
      throw TypeError('The service URL must be of a string type.');
    }
    this._serviceUrl = serviceUrl;
  }

  setUriParams(uriParams) {
    if (!isObject(uriParams)) {
      throw TypeError('The uri params must be of a object type.');
    }
    this._params = uriParams;
  }

  launch() {
    if (isEmptyString(this._serviceUrl)) {
      throw TypeError('Please set the service URL first.');
    }

    location = `nhn-proctor://launch${serialize({
      service_url: this._serviceUrl,
      version: '1.0.0.1',
      ...this._params
    })}`;
  }
}
